import { M3PItemsWEB, M3PDetalleItems } from "../Registro/m3-pdetalle-items";
import { TypeM3PrdGrp } from "../Maestro/M3PrdGrp.type";
import { M3RegService } from "./m3-reg-service";
import { M3CouchMaestro } from "../Data/m3-couch-maestro";
import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { ServiceM3Maestro } from "./M3Maestro.service";
import { M3Procesos } from "../Registro/m3-procesos";
import { M3PDinamicas } from "../Registro/m3-pdinamicas";
import { M3PerXProceso } from "../Registro/m3-per-x-proceso";
import { M3Ubicacion } from "../Maestro/Ubicacion/M3Ubicacion.type";

export class M3RegMasivo {

    private gsIdKatios: string;
    private reader: FileReader;
    private separador: string = ",";
    private oM3Proceso = new M3Procesos();
    private progress: number;
    private ConfMasiva: any;
    public rounded_progress: number;
    public gbBarCode: boolean = false;
    constructor(isIdKatios: string, ioM3Proceso: M3Procesos, iConfMasiva: any, ibBarcode: boolean) {
        this.oM3Proceso = ioM3Proceso;
        this.gsIdKatios = isIdKatios;
        this.ConfMasiva = iConfMasiva;
        this.gbBarCode = ibBarcode;
    }

    public get_rounded_progress() {
        return this.rounded_progress;
    }

    ///Adicionar productos en masivo
    public async AdicionarMasivo(oM3CouchMaestro: M3CouchMaestro, PostServiceM3: PostServiceM3, oDatUser: any, oDataProc: any) {
        this.GetReader(oDataProc);
        let csv: string;
        if (!this.reader) {
            csv = oDataProc.Text;
        }
        else {
            csv = this.reader.result.toString();
        }
        var arrCSV: Array<string> = csv.split("\n");

        var proceso = await this.adicionar_masivo_from_array(oM3CouchMaestro, PostServiceM3, oDatUser, arrCSV);

        return proceso;
    }

    /**
     * Recorre y adiciona los productos en un array a un proceso
     * @param oM3CouchMaestro 
     * @param PostServiceM3 
     * @param oDatUser 
     * @param arrCSV 
     */
    public async adicionar_masivo_from_array(oM3CouchMaestro: M3CouchMaestro, PostServiceM3: PostServiceM3, oDatUser: any, arrCSV: Array<string>, oM3Ubicacion: M3Ubicacion = null, aplExc: string = "0") {

        let total = arrCSV.length;
        let count = 0;
        var product: TypeM3PrdGrp
        var oServiceM3Maestro = new ServiceM3Maestro();
        var oM3RegService = new M3RegService(oM3CouchMaestro, PostServiceM3, this.gsIdKatios);

        this.progress = 0;

        for (var i = 0; i < total; i++) {
            var line: string = arrCSV[i];
            if (line) {
                var oestructCSV: estructCSV;
                oestructCSV = this.SetEstructCSV(line);
                if (this.gbBarCode) {
                    var data = { "id_ubicacion": oDatUser.UsuarioSistema.UBICACION, "Codigo": oestructCSV.sku };
                    product = await oServiceM3Maestro.Get_M3ProductoEspecByCodeAsync(PostServiceM3, this.gsIdKatios, data, oDatUser);
                } else {
                    console.debug(oM3Ubicacion);
                    console.debug(oM3Ubicacion && oM3Ubicacion.IDUbicacion);
                    if (oM3Ubicacion && oM3Ubicacion.IDUbicacion) {
                        product = await oServiceM3Maestro.M3GetProductoBySKUAsync(PostServiceM3, this.gsIdKatios, oestructCSV.sku, oDatUser, oM3Ubicacion.IDUbicacion, aplExc);
                    }
                    else {
                        product = await oServiceM3Maestro.M3GetProductoBySKUAsync(PostServiceM3, this.gsIdKatios, oestructCSV.sku, oDatUser, "-1", aplExc);
                    }
                }

                this.setPrecioSiAPlica(product, oestructCSV);
                this.AddPrdToM3Proceso(product, oestructCSV, oM3RegService, oDatUser, oM3Ubicacion);
            }
            count++;
            this.progress = count * 100 / total;
            this.rounded_progress = Math.round(this.progress * 100) / 100
        }
        return this.oM3Proceso;
    }

    //Cambiar precio de producto.
    public setPrecioSiAPlica(product: TypeM3PrdGrp, oestructCSV: estructCSV) {
        if (oestructCSV.precio !== NaN && oestructCSV.precio != null) {
            product.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO = oestructCSV.precio;
            product.LoM3PrdGeneral[0].LoM3PrdLista.M3Presentaciones.forEach(oM3Presentaciones => {
                oM3Presentaciones.VALOR = oestructCSV.precio;
            });
        }
    }

    //Adicionar a m3proceso, producto especifico, se envia cantidad.
    public AddPrdToM3Proceso(product: TypeM3PrdGrp, oestructCSV: estructCSV, oM3RegService: M3RegService, oDatUser: any, oM3Ubicacion: M3Ubicacion = null) {
        var oM3PItemsWEB = new M3PItemsWEB();
        oM3PItemsWEB.dCantidad = oestructCSV.cantidad;
        if (oestructCSV.PathImagen) {
            oM3PItemsWEB.PathImagen = oestructCSV.PathImagen;
        }
        oM3PItemsWEB = oM3RegService.LoadAdicionales(oM3PItemsWEB, product);

        if (this.oM3Proceso.M3ENC.length == 0) {
            ///Primera vez 
            ///NO SE ESTA ENVIANDO INFORMACION DE PROMOCIONES
            this.oM3Proceso = oM3RegService.LoadM3ProcesoEmptyPDB(product, oM3PItemsWEB, oDatUser, oM3Ubicacion, null, this.oM3Proceso);
            //Agregar dinamicas
            this.AdicionarDinamica(oestructCSV);
            this.AdicionarPersonasAProceso(oestructCSV);

        } else {
            oM3RegService.LoadM3ProcesoFromData(this.oM3Proceso, product, oM3PItemsWEB, oM3Ubicacion, null, oDatUser);
        }
        this.AdicionarDetalle(oestructCSV);
    }

    /**
     * Adicionar capturas dinamicas
     * @param oestructCSV Estructura con informacion de linea a agregar
     */
    public AdicionarDinamica(oestructCSV: estructCSV) {
        try {
            var dinamicas = oestructCSV.Dinamicas
            for (var i = 0; i < dinamicas.length; i++) {
                var oM3PDinamicas = new M3PDinamicas();
                if (!this.oM3Proceso.lM3PDinamicas) {
                    this.oM3Proceso.lM3PDinamicas = new Array<M3PDinamicas>();
                }
                oM3PDinamicas.Nombre = dinamicas[i].Atributo;
                oM3PDinamicas.Valor = dinamicas[i].Valor;
                this.oM3Proceso.lM3PDinamicas.push(oM3PDinamicas);
            }
        } catch (ex) {
            console.log("Error adicionar dinamica")
            console.log(ex)
        }
    }

    /**
     * Adicionar personas a proceso
     * @param oestructCSV Estructura con informacion a agregar
     */
    public AdicionarPersonasAProceso(oestructCSV: estructCSV) {
        try {
            var personas = oestructCSV.Personas;
            for (var i = 0; i < personas.length; i++) {
                var oM3PerXProceso = new M3PerXProceso();
                if (!this.oM3Proceso.M3PerXProceso) {
                    this.oM3Proceso.M3PerXProceso = new Array<M3PerXProceso>();
                }
                oM3PerXProceso.Tdoc = personas[i].Tdoc;
                oM3PerXProceso.Ndoc = personas[i].Ndoc;
                oM3PerXProceso.TipoPersona = personas[i].Atributo;
                this.oM3Proceso.M3PerXProceso.push(oM3PerXProceso);
            }
        } catch (ex) {
            console.log("Error adicionar personas")
            console.log(ex)
        }
    }

    /**
     * Adicionar detalle al ultimo encabezado agregado.
     * @param oestructCSV Estructura con informacion de linea a agregar
     */
    public AdicionarDetalle(oestructCSV: estructCSV) {
        try {
            var detalles = oestructCSV.M3Det
            for (var i = 0; i < detalles.length; i++) {
                var oM3PDetalleItems = new M3PDetalleItems();

                oM3PDetalleItems.NombreConcepto = detalles[i].Atributo;
                oM3PDetalleItems.Valor = detalles[i].Valor;
                this.oM3Proceso.M3ENC[this.oM3Proceso.M3ENC.length - 1].M3DET.push(oM3PDetalleItems);
                //this.oM3Proceso.M3ENC.find(x => x.IdProducto == oestructCSV.)
            }
        } catch (ex) {
            console.log("Error adicionar detalle")
            console.log(ex)
        }
    }


    ///Obtener y setear la informacion de archivo CSV y separador.
    public GetReader(oDataProc: any) {
        this.reader = oDataProc.CSV;
        this.separador = oDataProc.Separador;

    }


    ///Setear estrucutar de CSV
    public SetEstructCSV(line: string) {
        try {
            var oestructCSV: estructCSV = { "cantidad": null, "precio": null, "sku": null, "PathImagen": null, "Dinamicas": [], "Personas": [], "M3Det": [] };
            var oArrCSV: Array<string> = line.split(this.separador);

            if (this.ConfMasiva && this.ConfMasiva.Columnas) {
                oestructCSV = this.EstructDynamic(oArrCSV);
            } else {
                oestructCSV = this.EstructDefault(oArrCSV);
            }

            return oestructCSV;
        } catch (ex) {
            console.log("Error creando estructura. Revisar lineas");
            console.log(ex);
            return null;
        }
    }

    /**
     * Estructura dinamica de cargue masiva
     * @param oArrCSV arreglo con informacion.
     */
    public EstructDynamic(oArrCSV: Array<string>) {
        var columnas: Array<any> = this.ConfMasiva.Columnas;
        var oestructCSV: estructCSV = { "cantidad": null, "precio": null, "sku": null, "PathImagen": null, "Dinamicas": [], "Personas": [], "M3Det": [] };

        for (var i = 0; i < columnas.length; i++) {
            switch (columnas[i].Estructura) {
                case "Cantidad":
                    oestructCSV.cantidad = +oArrCSV[columnas[i].Posicion];
                    break;
                case "Precio":
                    oestructCSV.precio = +oArrCSV[columnas[i].Posicion];
                    break;
                case "SKU":
                    oestructCSV.sku = oArrCSV[columnas[i].Posicion];
                    break;
                case "DINAMICA":
                    var din = { "Atributo": columnas[i].Atributo, "Valor": oArrCSV[columnas[i].Posicion] };
                    oestructCSV.Dinamicas.push(din);
                    break;
                case "M3DET":
                    var m3Det = { "Atributo": columnas[i].Atributo, "Valor": oArrCSV[columnas[i].Posicion] };
                    oestructCSV.M3Det.push(m3Det);
                    break;
                case "TIPOPERSONA":
                    var valor = oArrCSV[columnas[i].Posicion];
                    var tdoc: string = "5";
                    var ndoc: string;

                    if (valor.split("-").length >= 2) {
                        tdoc = valor.split("-")[0];
                        ndoc = valor.split("-")[0];
                    } else {
                        ndoc = valor;
                    }

                    var persona = { "Atributo": columnas[i].Atributo, "Tdoc": tdoc, "Ndoc": ndoc };
                    oestructCSV.Personas.push(persona);
                    break;
                default:
                    break;
            }
        }
        return oestructCSV;
    }

    /**
     * Estructura default.
     * @param oArrCSV Arreglo con informacion
     */
    public EstructDefault(oArrCSV: Array<string>) {
        var oestructCSV: estructCSV = { "cantidad": null, "precio": null, "sku": null, "PathImagen": null, "Dinamicas": [], "Personas": [], "M3Det": [] };
        //var oArrCSV: Array<string> = line.split(this.separador);

        if (oArrCSV.length >= 1) {
            oestructCSV.sku = oArrCSV[0];
        }
        if (oArrCSV.length >= 2) {
            oestructCSV.cantidad = +oArrCSV[1];
        }

        if (oArrCSV.length >= 3) {
            oestructCSV.precio = +oArrCSV[2];
        }
        if (oArrCSV.length >= 4) {
            oestructCSV.PathImagen = oArrCSV[3];
        }
        return oestructCSV;
    }


}


export interface estructCSV {
    sku: string;
    cantidad: number;
    precio: number;
    PathImagen: string;
    Dinamicas: Array<any>;
    Personas: Array<any>;
    M3Det: Array<any>;
}